import React, { useMemo } from 'react';

// Sorting function
const sortByTag = (a, b) => {
  if (a.tag_customer_id && !b.tag_customer_id) return -1;
  if (!a.tag_customer_id && b.tag_customer_id) return 1;
  return 0;
};

// Component to render individual tags
const renderTags = (tags, index) => (
  <div className="flex-column-top mr-1 pt-1" key={index}>
    {tags.map((tag, tagIndex) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className={`row ${tagIndex === 0 ? 'mb-1' : ''}`} key={tagIndex}>
        <span
          className={`tag lox-banner-tags lox-no-border has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary ${(tag.tag_customer_id || tag.tag_lead_id) ? 'is-danger' : 'is-info'}`}
          style={{ borderRadius: '0' }}
          data-tooltip={tag.description}
        >
          {tag.name}
        </span>
      </div>
    ))}
  </div>
);

const BannerTag = ({ bannerTags }) => {
  const sortedAndChunkedTags = useMemo(() => {
    const sortedTags = [...bannerTags].sort(sortByTag);
    const chunks = [];
    for (let i = 0; i < sortedTags.length; i += 2) {
      chunks.push(sortedTags.slice(i, i + 2));
    }
    return chunks;
  }, [bannerTags]);

  return sortedAndChunkedTags.map((chunk, index) => renderTags(chunk, index));
};

export default BannerTag;
